

export const anonymousMenuItems = [


    {
        id: 1,
        label: 'Accueil',
        icon: '',
        withIcon: true,
        subItems:[],
        link: '/', 
        
    },

    {
        id: 2,
        label: 'Concept',
        link: '/concept-sacs-publicitaires',
        icon: '4',
     
    },
    
    {
        id: 3,
        label: 'Atouts',
        link: '/atouts-sacs-publicitaires',
        icon: '4 ',
    },
    
    {
        id: 5,
        label: 'Partenaires',
        icon: '4',
        link: '/nos-partenaires',
    },

    {
        id: 4,
        label: 'Contact',
        icon: '4',
        link: '/contacter-nous',
    },

    {
        id: 6,
        label: 'Devis Gratuits',
        link: '/devis',

    },
 

];

